import React from 'react';
import { Container } from 'react-bootstrap';
import '../../../assets/css/customer/about/AboutHero.css';

const AboutHero = () => {
  return (
    <section className="about-hero-section">
      <Container>
        <div className="hero-content">
          {/* Main Heading */}
          <h1 className="hero-heading">Our Story</h1>

          {/* Description */}
          <p className="hero-description">
            Creating unforgettable moments and turning dreams into reality through
            exceptional wedding and event planning services
          </p>
        </div>
      </Container>
    </section>
  );
};

export default AboutHero;